import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import {IconButton, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {useSearchParams} from 'react-router-dom';

import useProfile from '../../../../../hooks/providers/useProfile';
import {flowShape} from '../../../../../proptypes-shapes';

const HeaderOnboardingSingleFlowStepsList = ({flow}) => {
  const {setSelectedFlow, setCurrentFlowStepId, setIsOnboardingModalOpen, setIsOnboardingPopperOpen} = useProfile();
  const [searchParams, setSearchParams] = useSearchParams();

  const openStepVideo = step => {
    setIsOnboardingPopperOpen(false);
    setIsOnboardingModalOpen(true);
    setSelectedFlow(flow);
    setCurrentFlowStepId(step.step_id);
    searchParams.set('videoId', step.step_id);
    setSearchParams(searchParams);
  };

  return (
    <Box mt={1} px={1}>
      {flow.steps.map(step => {
        const isStepCompleted = step.position === 100;

        return (
          <Grid key={step.step_id} container alignItems="center" mb={1.3} justifyContent="space-between" onClick={() => openStepVideo(step)}>
            <Grid item xs={10}>
              <Grid container alignItems="center" flexWrap="nowrap">
                {isStepCompleted ? <CheckCircleIcon color="primary" fontSize="small" /> : <RadioButtonUncheckedIcon fontSize="small" />}
                <Typography
                  sx={{
                    textDecoration: isStepCompleted ? 'line-through !important' : ''
                  }}
                  ml={0.5}
                  color="text.secondary"
                  fontSize={13}
                >
                  {step.title}
                </Typography>
              </Grid>
            </Grid>

            <Grid item>
              <IconButton aria-label="voir la vidéo" color="inherit" size="small">
                <VideoLibraryIcon sx={{fontSize: 14}} aria-label="Voir la vidéo" />
              </IconButton>
            </Grid>
          </Grid>
        );
      })}
    </Box>
  );
};

HeaderOnboardingSingleFlowStepsList.propTypes = {
  flow: flowShape.isRequired
};

export default HeaderOnboardingSingleFlowStepsList;
